import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import Blogs from "./Pages/Home/Blogs/Blogs";
import Home from "./Pages/Home/Home/Home";
import SingleProject from "./Pages/Home/SingleProject/SingleProject";
import Footer from "./Pages/Shared/Footer/Footer";
import Header from "./Pages/Shared/Header/Header";

function App() {
    const [loading, setLoading] = useState(true);
    return (
        <div className="App">
            <Router>
                <Header loading={loading} />
                <Switch>
                    <Route exact path="/">
                        <Home loading={loading} setLoading={setLoading} />
                    </Route>
                    <Route exact path="/home">
                        <Home loading={loading} setLoading={setLoading} />
                    </Route>

                    <Route path="/project/:projectId">
                        <SingleProject></SingleProject>
                    </Route>

                    <Route path="/blogs">
                        <Blogs></Blogs>
                    </Route>
                </Switch>
                <Footer></Footer>
            </Router>
        </div>
    );
}

export default App;
